<template>
  <img
    :src="image"
    :alt="alt"/>
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    image() {
      if (this.id) {
        return `${process.env.VUE_APP_BASE_URL}/attach/${this.id}`;
      }
      return '';
    },
  },
};
</script>
